import script from "./checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./checkbox.vue?vue&type=style&index=0&id=1905b52a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1905b52a"]])

export default __exports__